import { render, staticRenderFns } from "./ClientSelector.vue?vue&type=template&id=778f8366&scoped=true"
import script from "./ClientSelector.vue?vue&type=script&lang=js"
export * from "./ClientSelector.vue?vue&type=script&lang=js"
import style0 from "./ClientSelector.vue?vue&type=style&index=0&id=778f8366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778f8366",
  null
  
)

export default component.exports